<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-11 15:00:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-02-23 18:05:37
 * @FilePath:
 * @Description: 微信授权页面
-->
<template>
  <div></div>
</template>

<script>
import { setUserWxAuth } from "@/api/user";
export default {
  name: "ReportSetWxAuth",
  props: {},
  data() {
    return {};
  },
  components: {},
  created() {
    var pageQuery = this.$route.query;
    this.authId = pageQuery.EmployeeId;
    this.authVpnId = pageQuery.VpnId;
    this.$store.commit("set_vpnid", this.authVpnId);
    this.authType = pageQuery.PermissionType;
    if (!this.authId || !this.authVpnId || !this.authType) {
      this.$toast("缺少必要的参数，请检查链接");
    } else {
      this.handleSetWxAuth();
    }
  },
  mounted() {},
  methods: {
    handleSetWxAuth() {
      setUserWxAuth({
        EmployeeId: this.authId,
        VpnId: this.authVpnId,
        PermissionType: this.authType,
      })
        .then((res) => {
          this.$toast("授权成功！");
          // this.$router.push({ name: "StatisticsHome" });
           this.$router.go(-1)
					 this.$router.back();
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped lang="scss"></style>
